export enum CollegeLessonType {
  AREA = 'PRODUCING_AREA',
  BASIC = 'BASIC',
}

export enum CollegeLessonStatus {
  PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}
